export default "__VITE_ASSET__CYoGGRFN__"